import React, { useEffect, useState } from "react";

import "./AmpAccordian.css"

export interface AmpAccordianProps {
    title: string;
    content: string | JSX.Element;
    isOpen?: boolean;
    openOnlyOne?: boolean;
}

export default function AmpAccordian(props: AmpAccordianProps): JSX.Element{

    const [isOpen, toggleOpen] = useState(false);
    useEffect(() => {
      toggleOpen(props.isOpen || false)
    }, [props.isOpen])
  
    return (
        <div className={`amp-accordian-element ${isOpen ? "open" : ""}`}>  
            <h3 tabIndex={0} onClick={() => {toggleOpen(!isOpen)}}>{props.title}</h3>
            {typeof props.content === "string" ? 
            <p className="accordian-content">
                {props.content}
            </p> : 
            <div className="accordian-content">{props.content as JSX.Element}</div>}
        </div>
    )
}
